import { profile } from "./profile/profile_v2.js";
import { colors } from "./colors_v2.js";
import { join } from "./matches/join_v2.js";
import { newMatch } from "./matches/newMatch_v2.js";
import { currentMatch } from "./matches/currentMatch_v2.js";
import { recentMatches } from "./matches/recentMatches_v2.js";
import { help } from "./help_v2.js";
import { leaderboard } from "./leaderboard_v2.js";
import { eventHub } from "./eventHub_v2.js";

const hamburgerState = {
  isVisible: false,
};

const toggleNav = (nav) => {
  const classArray = Array.from(nav.classList);
  if (classArray.includes("displayFlex")) {
    nav.classList.remove("displayFlex");

    return;
  }
  if (!classArray.includes("displayFlex")) {
    nav.classList.add("displayFlex");
    return;
  }
};

const close = () => {
  hamburgerState.isOpen = false;
  const hamburger = document.getElementById("hamburger");
  hamburger.style.display = "block";

  const mobileNavBackground = document.getElementById("mobileNavBackground");
  mobileNavBackground.style.display = "none";
  //mobileNavBackground.classList.remove("is-active");

  const profileNav = document.getElementById("profileNav");
  profileNav.classList.remove("displayFlex");
  const joinNav = document.getElementById("joinNav");
  joinNav.classList.remove("displayFlex");
  const newNav = document.getElementById("newNav");
  newNav.classList.remove("displayFlex");
  const currentMatchNav = document.getElementById("currentMatchNav");
  currentMatchNav.classList.remove("displayFlex");
  const recentMatchesNav = document.getElementById("recentMatchesNav");
  recentMatchesNav.classList.remove("displayFlex");
  const leaderboardNav = document.getElementById("leaderboardNav");
  leaderboardNav.classList.remove("displayFlex");
  const helpNav = document.getElementById("helpNav");
  helpNav.classList.remove("displayFlex");
  document.getElementById("navContainer").classList.remove("vw25");
};

const handleClick = () => {
  hamburgerState.isOpen = true;
  const hamburger = document.getElementById("hamburger");
  hamburger.style.display = "none";

  const mobileNavBackground = document.getElementById("mobileNavBackground");
  mobileNavBackground.style.display = "flex";
  mobileNavBackground.style.backgroundColor =
    colors.getGameColor("lighterAccent");

  const profileNav = document.getElementById("profileNav");
  toggleNav(profileNav);
  profile.render("small");

  const joinNav = document.getElementById("joinNav");
  toggleNav(joinNav);
  join.render("small");

  const newNav = document.getElementById("newNav");
  toggleNav(newNav);
  newMatch.render("small");

  const currentMatchNav = document.getElementById("currentMatchNav");
  toggleNav(currentMatchNav);
  currentMatch.render("small");

  const recentMatchesNav = document.getElementById("recentMatchesNav");
  toggleNav(recentMatchesNav);
  recentMatches.render("small");

  const leaderboardNav = document.getElementById("leaderboardNav");
  toggleNav(leaderboardNav);
  leaderboard.render("small");

  const helpNav = document.getElementById("helpNav");
  toggleNav(helpNav);
  help.render("small");

  mobileNavBackground.classList.add("is-active");
  document.getElementById("navContainer").classList.add("vw25");
};

const isOpen = () => {
  return hamburgerState.isOpen;
};

eventHub.registerEvent("click", "closeMobileNav", close);

export const hamburger = {
  handleClick,
  close,
  isOpen,
};
